import * as yup from "yup";

export const GalleryFolderValidation = yup.object().shape({
    name: yup.string().trim().required("Folder name is required"),
    activity_id: yup.string().required("Activity is required"),
    description: yup.string().nullable(),
});
